import { Link } from 'react-router-dom';
import { APP_URL, DEMO_CTA_HREF } from '@/config';
import { Brand } from './v2/ui';
export function Footer() {
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <Brand light />
            <p>Intelligence infrastructure for your Product &amp; GTM.</p>
          </div>
          <div>
            <h2>Platform</h2>
            <Link to="/platform">Explore the platform</Link>
            <Link to="/#how-it-works">How it works</Link>
            <a href={DEMO_CTA_HREF}>Experience Foxet</a>
            <Link to="/enterprise">Enterprise</Link>
          </div>
          <div>
            <h2>Solutions</h2>
            <Link to="/product">Product</Link>
            <Link to="/pre-sales">Sales &amp; Pre-sales</Link>
            <Link to="/marketing">Marketing</Link>
            <Link to="/training">Onboarding &amp; Training</Link>
            <Link to="/support">Customer Support</Link>
          </div>
          <div>
            <h2>Company</h2>
            <a href="https://app.foxet.ai/talk/foxet-ai-v1-1">Talk to Sales</a>
            <Link to="/contact">Contact</Link>
            <a
              href="https://www.linkedin.com/company/foxet-ai"
              target="_blank"
              rel="noopener noreferrer"
            >
              LinkedIn
            </a>
            <a href={`${APP_URL}/login`}>Log in</a>
          </div>
          <div>
            <h2>Legal</h2>
            <Link to="/privacy">Privacy</Link>
            <Link to="/terms">Terms</Link>
          </div>
        </div>
        <div className="footer-bottom">
          <span>© {new Date().getFullYear()} Foxstack Inc. · Foxet.ai · Built in Bengaluru, India</span>
          <a href="mailto:hello@foxet.ai">hello@foxet.ai</a>
        </div>
      </div>
    </footer>
  );
}
